import Ghost from 'react-loading-skeleton';
import { Layout } from '../Layout';
const Wrapper: React.FC = () => <></>

const Button = (
	<Ghost wrapper={Wrapper} width={20} height={20} className="d-block" />
);

export const Skeleton = () => (
	<Layout
		delete={Button}
		duplicate={Button}
		edit={Button}
		divProps={{ className: 'cart-buttons-skeleton' }}
	/>
);
